// 导入类型定义
import { Translations, UnitsLocale } from "./locales/locale";

// 导入翻译文件
import * as en from "./locales/en";
import * as es from "./locales/es";
import * as zh from "./locales/zh";

export const locales = {
  en: en,
 // es: es,  /// 暂时注销西班牙语
  zh: zh,  // 添加中文
};

export const symbols = {
  es: { decimals: ",", groups: "." },
  en: { decimals: ".", groups: "," },
  zh: { decimals: ".", groups: "," }, // 添加中文
  pt: { decimals: ",", groups: "." },
  fr: { decimals: ",", groups: " " },
};

export type Locale = "zh" | "en";  //  | "es" | "pt" | "fr";

export const languageConfig: Array<{
  code: Locale;
  name: string;
  experimental?: boolean;
}> = [
  { code: "zh", name: "简体中文 (zh)" },
  { code: "en", name: "English (US)" },
  // { code: "es", name: "Español (ES)" },
  // { code: "pt", name: "Português (BR)", experimental: true },
  // { code: "fr", name: "Français (FR)", experimental: true },
];

export const stableLanguages: Locale[] = languageConfig
  .filter((lang) => !lang.experimental)
  .map((lang) => lang.code);

export const allSupportedLanguages: Locale[] = languageConfig.map(
  (lang) => lang.code,
);

export const getLocale = (): Locale => {
  if (typeof window === "undefined") return "en"; // "en" "zh"

  try {
    const savedValue = localStorage.getItem("locale");
    if (savedValue) {
      const savedLocale = JSON.parse(savedValue) as Locale;
      if (allSupportedLanguages.includes(savedLocale)) {
        return savedLocale;
      }
    }
  } catch {}

  const language = navigator.language;
  const code = stableLanguages.find(
    (code) => language === code || language.startsWith(`${code}-`),
  );
  return code || "en"; // "en" "zh"
};
